import { useNavigate } from "react-router-dom";
import { useI18n } from "@/i18n";
import { usePageMeta } from "@/lib/format";
import { ChevronLeft, Infinity as InfinityIcon, Leaf, Activity, Sparkles, AlertCircle, Info } from "lucide-react";

function Section({ title, body, icon: Icon }) {
  return (
    <div className="space-y-1.5 rounded-xl bg-secondary/60 p-4">
      <div className="flex items-center gap-2">
        <Icon className="h-4 w-4 text-primary" />
        <h3 className="font-display text-base text-foreground">{title}</h3>
      </div>
      <p className="text-sm leading-relaxed text-muted-foreground">{body}</p>
    </div>
  );
}

export default function ConnectedBreath() {
  const { t } = useI18n();
  const navigate = useNavigate();
  usePageMeta(t("connected_intro_title"));

  return (
    <div className="mx-auto max-w-xl" data-testid="connected-breath">
      <div className="mb-4 flex items-center gap-3">
        <button onClick={() => navigate(-1)} data-testid="conn-back" className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary/60 hover:bg-accent"><ChevronLeft className="h-5 w-5" /></button>
        <h1 className="font-display text-xl text-foreground">{t("connected_intro_title")}</h1>
      </div>

      <div className="space-y-4">
        <div className="flex flex-col items-center gap-2 text-center">
          <span className="flex h-16 w-16 items-center justify-center rounded-full" style={{ backgroundColor: "#EDCB9224" }}><InfinityIcon className="h-7 w-7" style={{ color: "#EDCB92" }} /></span>
          <h2 className="font-display text-2xl text-foreground">{t("connected_intro_title")}</h2>
          <p className="max-w-md text-sm leading-relaxed text-muted-foreground">{t("connected_intro_body")}</p>
        </div>

        <Section title={t("connected_what_it_is")} body={t("connected_what_body")} icon={Leaf} />
        <Section title={t("connected_how_works")} body={t("connected_how_body")} icon={Activity} />
        <Section title={t("connected_benefits")} body={t("connected_benefits_body")} icon={Sparkles} />

        <div className="flex gap-3 rounded-xl border-l-4 p-4" style={{ borderLeftColor: "#B85C5C", backgroundColor: "#B85C5C15" }}>
          <AlertCircle className="h-5 w-5 shrink-0" style={{ color: "#B85C5C" }} />
          <div>
            <p className="font-display text-sm" style={{ color: "#B85C5C" }}>{t("connected_safety")}</p>
            <p className="mt-1 text-xs leading-relaxed text-foreground">{t("connected_safety_body")}</p>
          </div>
        </div>

        <div className="flex items-center gap-2 px-1">
          <Info className="h-4 w-4 text-muted-foreground" />
          <p className="text-xs italic text-muted-foreground">{t("connected_facilitator_only")}</p>
        </div>

        <button onClick={() => navigate(-1)} data-testid="conn-close" className="w-full rounded-full bg-primary py-3 font-semibold text-primary-foreground">{t("connected_close")}</button>
      </div>
    </div>
  );
}
